import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import { Form, FormField } from "components/Form"
import { apiPUT, apiGET, apiPOST } from "utils/api"
import { LOGO_CROP_SIZE } from "utils/constants"
import { reverse } from "utils/urls"

export default function AirlineForm(props) {
  const [formData, setFormData] = useState({})

  const { t } = useTranslation()

  useEffect(
    () =>
      props.isUpdate
        ? apiGET({
            path: `/airlines/${props.match.params.id}/`,
            onSuccess: response => setFormData(response),
            onError: () => props.history.push(reverse("airlineList")),
          })
        : () => {},
    [props.isUpdate, props.match.params.id, props.history]
  )

  return (
    <div>
      <Form
        endpoint={props.actionEndpoint}
        apiFunction={props.isUpdate ? apiPUT : apiPOST}
        defaultValues={formData}
        successUrl={props.successUrl}
        successMessage={t("Airline was successfully saved.")}
        title={props.isUpdate ? t("Edit airline") : t("Add airline")}>
        <div className="row">
          <div className="col-4">
            <FormField
              name="name"
              fieldType="input"
              type="text"
              label={t("Name")}
              maxLength={50}
              required
            />
          </div>
          <div className="col-4">
            <FormField
              name="address"
              fieldType="input"
              type="text"
              label={t("Address")}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <FormField
              name="code"
              fieldType="input"
              type="text"
              label={t("Code")}
              maxLength={3}
              required
            />
          </div>
          <div className="col-4">
            <FormField
              name="city"
              fieldType="selectWithAdd"
              selectFieldType="asyncSelect"
              label={t("City")}
              endpoint="/cities/"
              required
              addRoute="cityCreate"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <FormField
              name="codeAs400"
              fieldType="input"
              type="text"
              label={t("Code AS400")}
              maxLength={15}
              required
            />
          </div>
          <div className="col-4">
            <FormField
              name="zipCode"
              fieldType="input"
              type="text"
              label={t("Zip Code")}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <FormField
              name="colorCode"
              fieldType="input"
              type="text"
              label={t("Color")}
            />
          </div>
          <div className="col-4">
            <FormField
              name="url"
              fieldType="input"
              type="text"
              label={t("Web address")}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <FormField
              name="logoBase64"
              fieldType="image"
              label={t("Logo")}
              cropSize={LOGO_CROP_SIZE}
              defaultValue={formData.logoBase64}
            />
          </div>
        </div>
      </Form>
    </div>
  )
}

AirlineForm.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string,
    }),
  }).isRequired,
  isUpdate: PropTypes.bool,
  actionEndpoint: PropTypes.string.isRequired,
  successUrl: PropTypes.string.isRequired,
}

AirlineForm.defaultProps = {
  isUpdate: false,
}
